document.addEventListener('DOMContentLoaded', function() {
    // Keep megamenu in its server-rendered position.
    // Runtime DOM reparenting caused major MainContent CLS spikes.

    const megamenuRoot = document.querySelector('.shopify-section.omx-megamenu-section');
    const menu = megamenuRoot ? megamenuRoot.querySelector('.menu') : document.querySelector('.menu');
    const menuMain = menu ? menu.querySelector(".menu-main") : null;
    const goBack = menu ? menu.querySelector(".go-back") : null;
    const menuTrigger = document.querySelector(".mobile-menu-trigger");
    const closeMenu = menu ? menu.querySelector(".mobile-menu-close") : null;
    const menuOverlay = megamenuRoot
      ? megamenuRoot.querySelector(".menu-overlay")
      : document.querySelector(".menu-overlay");
    let subMenu;
    const hasLegacyMobileMenu = Boolean(menu && menuMain && goBack && menuTrigger && closeMenu && menuOverlay);
  
    // Handle mobile menu submenu navigation
    if (hasLegacyMobileMenu) {
      menuMain.addEventListener("click", (e) => {
        if (!menu.classList.contains("active")) {
          return;
        }
        
        // Check if the click is on a menu item with children
        const menuItem = e.target.closest(".menu-item-has-children");
        if (menuItem) {
          const clickedLink = e.target.closest("a");
          const menuLink = menuItem.querySelector("a");
          
          // Only handle clicks on the main menu link, not submenu links
          if (clickedLink === menuLink) {
            const href = menuLink.getAttribute('href');
            if (href === '#' || href === null) {
              e.preventDefault();
              e.stopPropagation();
              showSubMenu(menuItem);
            }
            // If href is not #, let it navigate normally
          }
          // If click is not on the main menu link, let it work normally
        }
        // All other links will work normally
      });
    
      goBack.addEventListener("click", () => {
        hideSubMenu();
      });
    
      menuTrigger.addEventListener("click", () => {
        toggleMenu();
      });

      menuTrigger.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleMenu();
        }
      });
    
      closeMenu.addEventListener("click", () => {
        toggleMenu();
      });
    
      menuOverlay.addEventListener("click", () => {
        toggleMenu();
      });

      // When header search opens on mobile, force-close the legacy mobile menu.
      document.addEventListener("omx:header-search-open", () => {
        if (window.innerWidth >= 990) return;
        closeMobileMenu();
      });
    }
  
    function toggleMenu() {
      if (!hasLegacyMobileMenu) return;
      menu.classList.toggle("active");
      menuOverlay.classList.toggle("active");
      var open = menu.classList.contains("active");
      if (menuTrigger) {
        menuTrigger.setAttribute("aria-expanded", open ? "true" : "false");
      }
      if (menuOverlay) {
        menuOverlay.setAttribute("aria-hidden", open ? "false" : "true");
      }
      document.body.classList.toggle("overflow-hidden", open);
      document.body.classList.toggle("omx-mobile-nav-open", open);
    }
  
    function showSubMenu(hasChildren) {
      if (!hasLegacyMobileMenu) return;
      subMenu = hasChildren.querySelector(".omx-sub-menu");
      subMenu.classList.add("active");
      subMenu.style.animation = "slideLeft 0.5s ease forwards";
      const menuLink = hasChildren.querySelector(":scope > a");
      var menuTitle = "";
      if (menuLink) {
        menuTitle = Array.from(menuLink.childNodes)
          .filter(function (n) {
            return n.nodeType === Node.TEXT_NODE;
          })
          .map(function (n) {
            return n.textContent;
          })
          .join("")
          .trim();
        if (!menuTitle) {
          menuTitle = menuLink.textContent.replace(/\s+/g, " ").trim();
        }
      }
      menu.querySelector(".current-menu-title").innerHTML = menuTitle;
      menu.querySelector(".mobile-menu-head").classList.add("active");
    }
  
    function hideSubMenu() {
      if (!hasLegacyMobileMenu || !subMenu) return;
      subMenu.style.animation = "slideRight 0.5s ease forwards";
      setTimeout(() => {
        subMenu.classList.remove("active");
      }, 300);
      menu.querySelector(".current-menu-title").innerHTML = "";
      menu.querySelector(".mobile-menu-head").classList.remove("active");
    }

    function closeMobileMenu() {
      if (!hasLegacyMobileMenu) return;

      if (subMenu) {
        subMenu.classList.remove("active");
        subMenu.style.animation = "";
        subMenu = null;
      }

      menu.querySelector(".current-menu-title").innerHTML = "";
      menu.querySelector(".mobile-menu-head").classList.remove("active");

      if (menu.classList.contains("active")) {
        toggleMenu();
      }
    }
  
    // for mobile view accordion
    var accordionHeaders = document.querySelectorAll('.omx-accordion');
  
    accordionHeaders.forEach(function(header) {
      header.addEventListener('click', function(e) {
        // Only enable accordion behavior on mobile (below 990px)
        if (window.innerWidth >= 990) {
          return;
        }
        
        var panel = this.nextElementSibling;
  
        // Check if this accordion is already active
        var isActive = this.classList.contains('active');
  
        // Close all accordions
        accordionHeaders.forEach(function(otherHeader) {
          otherHeader.classList.remove('active');
          otherHeader.nextElementSibling.style.maxHeight = null;
        });
  
        // Open the clicked accordion if it was not active
        if (!isActive) {
          this.classList.add('active');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });

    // FAQ links: Navigation + Menü-Verhalten (Mobile + Desktop)
    var faqLinks = document.querySelectorAll('.faq-reload-link');

    function normalizePathname(pathname) {
      if (!pathname) return '';
      var p = pathname.replace(/\/$/, '');
      return p === '' ? '/' : p;
    }

    function isSameDocumentAs(url) {
      return (
        normalizePathname(url.pathname) === normalizePathname(window.location.pathname) &&
        url.search === window.location.search
      );
    }

    function scrollToFaqFragment(fragment) {
      if (!fragment || fragment.charAt(0) !== '#') return;
      var id = fragment.slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /** Dawn MenuDrawer: nach FAQ-Klick bleibt das Drawer sonst offen (Trap/overflow/nested details) → zweites Öffnen kaputt. */
    function closeHeaderDrawerIfOpen() {
      try {
        var hdr = document.querySelector('header-drawer');
        if (!hdr) return;
        var mainDetails = hdr.querySelector('details');
        if (!mainDetails || !mainDetails.hasAttribute('open')) return;
        var hamburgerSummary = mainDetails.querySelector(':scope > summary');
        if (hamburgerSummary) {
          hamburgerSummary.click();
        }
      } catch (err) {}
    }

    faqLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var href = this.getAttribute('href');
        if (!href) {
          return;
        }

        var targetUrl;
        try {
          targetUrl = new URL(href, window.location.origin);
        } catch (err) {
          window.location.href = href;
          return;
        }

        if (hasLegacyMobileMenu && menu.classList.contains('active')) {
          toggleMenu();
        }

        var sameDoc = isSameDocumentAs(targetUrl);

        // Desktop: FAQ-Megamenu nach Klick zuverlässig zu — nur per mouseleave wieder erlauben.
        // (setTimeout war falsch: Cursor bleibt oft über dem li → nach Ablauf greift :hover wieder.)
        if (window.innerWidth > 989 && sameDoc) {
          var faqSubMenu = document.querySelector('.mega-menu-column-faq');
          if (faqSubMenu) {
            var faqMenuItem = faqSubMenu.closest('.menu-item-has-children');
            if (faqMenuItem) {
              faqMenuItem.classList.add('menu-force-hide');
              if (faqMenuItem._omxFaqMegamenuLeave) {
                faqMenuItem.removeEventListener('mouseleave', faqMenuItem._omxFaqMegamenuLeave);
              }
              faqMenuItem._omxFaqMegamenuLeave = function () {
                faqMenuItem.classList.remove('menu-force-hide');
                faqMenuItem.removeEventListener('mouseleave', faqMenuItem._omxFaqMegamenuLeave);
                faqMenuItem._omxFaqMegamenuLeave = null;
              };
              faqMenuItem.addEventListener('mouseleave', faqMenuItem._omxFaqMegamenuLeave);
            }
          }
        }

        if (sameDoc) {
          if (targetUrl.hash) {
            var frag = targetUrl.hash;
            if (window.location.hash === frag) {
              scrollToFaqFragment(frag);
              try {
                window.dispatchEvent(new HashChangeEvent('hashchange', { oldURL: window.location.href, newURL: window.location.href }));
              } catch (err2) {
                window.dispatchEvent(new Event('hashchange'));
              }
            } else {
              window.location.hash = frag;
            }
          } else {
            window.location.href = href;
          }
          setTimeout(closeHeaderDrawerIfOpen, 0);
          return;
        }

        window.location.href = href;
        setTimeout(closeHeaderDrawerIfOpen, 0);
      });
    });
  
    // Handle desktop menu behavior for menu items with submenus
    const menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children > a');
  
  
    menuItemsWithChildren.forEach(function(link) {
      link.addEventListener('click', function(e) {
        // On desktop, prevent navigation for menu items with submenus (they should show megamenu on hover)
        if (window.innerWidth > 989) {
          if (this.getAttribute('href') === '#' || this.getAttribute('href') === null) {
            e.preventDefault();
          }
        }
        // On mobile, let the menuMain click handler handle it
      });
    });



    window.onresize = function() {
      if (this.innerWidth > 991) {
        if (hasLegacyMobileMenu && menu.classList.contains("active")) {
          toggleMenu();
        }
      }
      
      // Clear accordion inline styles when resizing to desktop
      if (this.innerWidth >= 990) {
        accordionHeaders.forEach(function(header) {
          var panel = header.nextElementSibling;
          if (panel && panel.classList.contains('omx-accordion-panel')) {
            panel.style.maxHeight = '';
          }
        });
      }
    };
  }); 